<template>
  <div v-cloak v-if="loaded">
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <form>
          <div class="vx-row">
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <label class="vs-select--label">{{ $t("AgentName") }}</label>
              <vs-input
                class="inputx mt-1"
                v-model="basketModel.basketCustomerInfo.name"
                readonly="readonly"
              />
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full mb-2">
              <label class="vs-select--label">{{ $t("Product") }}</label>
              <v-select
                label="persianName"
                name="product"
                :options="setAgentProducts"
                @input="onProductSelected"
                ref="productSelection"
                dir="rtl"
              >
              </v-select>
            </div>
          </div>
        </form>
        <div class="vx-row">
          <div class="vx-col w-full mb-2 mt-4">
            <vs-table :data="products" class="custom-tbl">
              <template slot="thead">
                <th style="width: 5%">#</th>
                <th style="width: 40%">{{ $t("ProductName") }}</th>
                <th style="width: 15%">{{ $t("Price") }}</th>
                <th style="width: 15%">{{ $t("ItemCode") }}</th>
                <th style="width: 10%">{{ $t("Count") }}</th>
                <th style="width: 15%">{{ $t("Action") }}</th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="i" v-for="(index, i) in data">
                  <vs-td>
                    {{ i + 1 }}
                  </vs-td>
                  <vs-td>
                    {{ data[i].productName }}
                  </vs-td>
                  <vs-td>
                    {{ Number(data[i].price).toLocaleString()
                    }}{{ $t("Rials") }}
                  </vs-td>

                  <vs-td>
                    {{ data[i].itemCode }}
                  </vs-td>
                  <vs-td class="count-input">
                    <vs-input
                      v-model="data[i].count"
                      name="count"
                      v-validate="{ regex: '^([0-9]+)$', required: 'true' }"
                      :class="{ 'is-invalid': errors.has('count') }"
                    />
                  </vs-td>
                  <vs-td>
                    <vs-button
                      radius
                      color="danger"
                      size="small"
                      type="gradient"
                      icon-pack="feather"
                      icon="icon-x"
                      @click.prevent="deletePro(i)"
                      class="d-inline"
                    ></vs-button>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full mb-2">
            <vs-button
              type="filled"
              class="float-right mb-4"
              id="submit-btn"
              @click.prevent="submitForm"
              :disabled="disabled"
              >{{ $t("Save") }}</vs-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
#submit-btn {
  margin-right: 2rem;
}

.count-input input {
  text-align: center !important;
}
</style>
<script>
import { mapGetters, mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import vSelect from "vue-select";
export default {
  name: "basketManagement_ChannelBaskets_EditBasket",
  components: {
    "v-select": vSelect
  },
  data() {
    return {
      loaded: false,
      model: {
        agent: null,
        productId: null
      },
      products: [],
      disabled: false,
      basketModel: [],
      updatedModel: {}
    };
  },
  computed: {
    ...mapGetters({
      agentBasket: "basket/agentBasketDetails",
      setAgentProducts: "sale/agentProducts"
    })
  },
  mounted() {
    this.load();
  },
  methods: {
    ...mapActions({
      fetchAgentProducts: "sale/fetchAgentProducts",
      fetchAgentBasket: "basket/fetchSaleAgentBasket",
      updateAgentBasket: "basket/updateSaleAgentBasket"
    }),
    load() {
      var id = this.$route.params.id;
      this.fetchAgentBasket(id).then(() => {
        this.basketModel = JSON.parse(JSON.stringify(this.agentBasket));
        var array = this.basketModel.saleAgentBasketItemsQueryDto;
        for (let i = 0; i < array.length; i++) {
          this.products.push({
            productId: array[i].basketProductInfo.productInfoId,
            productName: array[i].basketProductInfo.productInfoPersianName,
            itemCode: array[i].basketProductInfo.productInfoItemCode,
            count: array[i].count,
            price: array[i].price
          });
        }
        this.fetchAgentProducts(this.checkHaveMember(this.basketModel));
        // this.fetchAgentProducts(this.basketModel.basketCustomerInfo.customerId);
        // this.updatedModel.ownerUserId = this.basketModel.ownerUserId;
        this.updatedModel.basketId = this.basketModel.Id;

        setTimeout(() => {
          this.loaded = true;
        }, 0);
      });
    },
    checkHaveMember(basket) {
      if (basket.saleAgentInfoBasketQuery) {
        return basket.saleAgentInfoBasketQuery.saleAgentId;
      } else {
        return basket.basketCustomerInfo.customerId;
      }
    },
    onProductSelected(data) {
      if (data) {
        var array = this.products;
        var alreadyExisted = array.findIndex(x => x.itemCode == data.itemCode);
        if (alreadyExisted === -1) {
          array.push({
            productName: data.persianName,
            productId: data.productId,
            price: data.price,
            itemCode: data.itemCode
          });
        } else {
          this.$swal({
            position: "center-center",
            type: "warning",
            text: "کالا با این آیتم کد در لیست انتخابی از قبل موجود است!!",
            showConfirmButton: false,
            timer: 8000
          });
        }

        this.$refs.productSelection.clearSelection();
      }
    },
    deletePro(item) {
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر"
      }).then(result => {
        if (result.value) {
          this.products.splice(item, 1),
            this.$swal({
              position: "center-center",
              type: "success",
              text: "رکورد مورد‌نظر با موفقیت حذف شد!",
              showConfirmButton: false,
              timer: 2000
            });
        }
      });
    },
    submitForm() {
      this.updatedModel.basketItems = this.products;
      var id = this.basketModel.id;
      this.updatedModel.basketId = id;
      this.disabled = true;
      this.updateAgentBasket(this.updatedModel).then(() => {
        this.$router.push("/ChannelBaskets/BasketDetails/" + 1 + "/" + id);
      });
      this.disabled = false;
    }
  }
};
</script>
